<div class="mt-1">
    <cdx-tabset (onSelect)="tabSelect($event)" [childTemplate]="tabTemplate" [customSlider]="true"
        [customViewTabs]="tabs" [dropdown]="dropdown">
        <cdx-tab *ngFor="let tab of tabs; let index = index" [customView]="tab" (click)="tabClick(index)"></cdx-tab>
    </cdx-tabset>
    <ng-template #tabTemplate let-tab="context">
        {{tab.title | translate }}
        <div class="{{tab.badgeClass}}">{{ tab.badgeValue}}</div>
    </ng-template>
</div>
